import { writable } from 'svelte/store';
import { fbConfig } from '$lib/data/generated/fbConfig.js';

export const initialized = writable(false);

export async function fbInit() {
	if (typeof window !== 'undefined') {
		const { getApps } = await import('firebase/app');

		if (getApps().length === 0) {
			const { initializeApp } = await import('firebase/app');

			console.log('initializing app');
			initializeApp(fbConfig);

			initialized.set(true);
		}
	}
}
